import { formatCurrency, IjmSelection } from "../../../utils";
import { useI18n } from "../../../hooks/i18n-hooks";
import { useCallback } from "react";
import { IjmChoice } from "../../../__generated__/graphql";
import { editIjmSalaryInfo } from "../../../atoms/core";
import { useRecoilValue } from "recoil";

export const isSelectionValid = (selection?: IjmSelection): boolean => {
    return (
        selection?.ijmGroupId !== undefined &&
        selection?.ijmGroupId !== null &&
        selection?.ijmPayFirstDays !== undefined &&
        selection?.ijmPayFirstDays !== null &&
        selection?.ijmPayRemainingPercents !== undefined &&
        selection?.ijmPayRemainingPercents !== null
    );
};

export const getPayFirstDaysChoices = () => {
    return [
        { label: "ijm.ijm_pay_first_days.select.yes", value: true },
        { label: "ijm.ijm_pay_first_days.select.no", value: false },
    ];
};

export const getPayFirstDaysSetAndLabel = (key: boolean | null | undefined): [boolean, string] => {
    if (key === null || key === undefined) {
        return [false, "ijm.ijm_pay_first_days.select.place_holder"];
    } else if (key) {
        return [true, "ijm.ijm_pay_first_days.select.yes"];
    } else {
        return [true, "ijm.ijm_pay_first_days.select.no"];
    }
};

export const getPayRemainingPercentsChoices = () => {
    return [
        { label: "ijm.ijm_pay_remaining_percents.select.20", value: 20 },
        { label: "ijm.ijm_pay_remaining_percents.select.10", value: 10 },
        { label: "ijm.ijm_pay_remaining_percents.select.0", value: 0 },
    ];
};

export const getPayRemainingPercentsSetAndLabel = (
    key: number | null | undefined,
): [boolean, string] => {
    if (key === null || key === undefined) {
        return [false, "ijm.ijm_pay_remaining_percents.select.place_holder"];
    } else if (key === 0) {
        return [true, "ijm.ijm_pay_remaining_percents.select.0"];
    } else if (key === 10) {
        return [true, "ijm.ijm_pay_remaining_percents.select.10"];
    } else if (key === 20) {
        return [true, "ijm.ijm_pay_remaining_percents.select.20"];
    }
    return [true, `${key} %`];
};

export const useBuildGroupInfo = () => {
    const i18n = useI18n();
    const editIjmSalayInfo = useRecoilValue(editIjmSalaryInfo);
    return useCallback(
        (group: IjmChoice) => {
            const days = group.waitingPeriodDays;
            const startingDay = days + 1;
            const countingDays = days <= 2 ? 0 : days;

            const ret = [
                i18n.t("ijm.data.descriptions.item_1", { count: startingDay }),
                i18n.t("ijm.data.descriptions.item_2", { count: countingDays }),
            ];
            if (editIjmSalayInfo) {
                const salary = editIjmSalayInfo.amount;
                const amount = (salary * Number(group.clientRate)) / 100.0;
                const amountDisplay = i18n.t(`mission.salary_${editIjmSalayInfo.earningType}`, {
                    value: formatCurrency({ amountInCents: amount }),
                });

                ret.push(
                    i18n.t("ijm.data.descriptions.item_3", {
                        percent: group.clientRate,
                        amount: amountDisplay,
                    }),
                );
            } else {
                ret.push(
                    i18n.t("ijm.data.descriptions.item_3b", {
                        percent: group.clientRate,
                    }),
                );
            }
            return ret;
        },
        [editIjmSalayInfo, i18n],
    );
};
